import React, { CSSProperties, useCallback } from 'react';
import styled from 'styled-components';

const HashtagChipWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  border-radius: 8px;
  font-size: 11px;
  background-color: var(--buttonBackgroundColor);
  color: var(--buttonTextColor);
  font-family: var(--defaultFontFamily);
  transition: 0.2s;
  font-weight: 800;
  width: max-content;
`;

export const HashTagSec = styled.div`
  display: flex;
  width: 100%;
  gap: 6px;
`;

type Props = {
  value: string;
  onSearch?: boolean;
  style?: CSSProperties;
};

function HashtagChip({ value, onSearch, style }: Props) {
  const handleClickTag = useCallback((e, hashtagValue) => { }, []);

  return (
    <HashtagChipWrap onClick={(e) => handleClickTag(e, value)} style={style}>
      {value}
    </HashtagChipWrap>
  );
}

export default HashtagChip;
